import { restApiRP } from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApiRP.post("/api/rp-settings", params);
};

const getAllForCSV = params => {
return restApiRP.post("/api/rp-settings/csv", params);
};

const update = data => {
  return restApiRP.post("/api/rp-settings/save", data);
}

const recalculationEoq = data => {
  return restApiRP.post("/api/rp-settings/recalculation-eoq", data);
}

const rpPolicyService = {
  getAll,
  getAllForCSV,
  update,
  recalculationEoq
};

export default rpPolicyService;